<script setup lang="ts"></script>

<template>
  <icon name="lucide:list-plus" />
</template>

<style scoped></style>
